import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { trackHit } from "@/lib/analytics";

/**
 * Fires on every React Router navigation:
 *   1. GA4 page_view event (if gtag is available)
 *   2. In-house POST /api/hit (works even when GA is blocked by ad-blockers)
 */
export default function PageTracker() {
  const location = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const path = location.pathname + location.search;

    // Always start the new page from the top
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    // 1. Google Analytics
    const gtag = window.gtag;
    if (typeof gtag === "function") {
      gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
        send_to: "G-7KPDQ9EV08",
      });
    }

    // 2. In-house analytics
    trackHit(path, lang);
  }, [location, lang]);

  return null;
}
